import { useState } from "react";
import { Check, MoreHorizontal } from "lucide-react";

import type { ActionCard } from "@/types/actions";
import { Button } from "@/components/ui/button";
import { usePopover } from "@/hooks/use-popover";
import { ActionQueueLabels } from "@/lib/action-queue";
import type { ActionDecisionKind } from "@/types/actions";

import { ActionDecisionDialog } from "./action-decision-dialog";

const otherDecisions: ActionDecisionKind[] = ["contact", "wait", "transfer", "contest"];

export function ActionCardActions({ action }: { action: ActionCard }) {
	const menu = usePopover<HTMLDivElement>("right");
	const [decision, setDecision] = useState<{ kind: ActionDecisionKind; action: ActionCard } | null>(
		null,
	);
	const decisions =
		action.status === "aguardando" ? ["resume" as const, ...otherDecisions] : otherDecisions;

	const handleDecision = (kind: ActionDecisionKind) => {
		menu.setOpen(false);
		setDecision({ kind, action });
	};

	if (!action.can_manage) {
		return null;
	}

	return (
		<>
			<div className="flex items-center gap-1.5">
				<Button type="button" size="sm" onClick={() => handleDecision("complete")}>
					<Check />
					concluir
				</Button>
				<div ref={menu.rootRef} className="relative">
					<Button
						type="button"
						size="sm"
						variant="secondary"
						aria-label="outras decisões"
						data-slot="action-more"
						aria-haspopup="menu"
						aria-expanded={menu.open}
						onClick={() => menu.setOpen((open) => !open)}
					>
						<MoreHorizontal />
					</Button>
					{menu.open && (
						<div
							ref={menu.panelRef}
							popover="manual"
							role="menu"
							aria-label="outras decisões"
							className="popover-panel min-w-44 p-1"
						>
							{decisions.map((kind) => (
								<Button
									type="button"
									key={kind}
									role="menuitem"
									variant="ghost"
									size="sm"
									className="w-full justify-start"
									onClick={() => handleDecision(kind)}
								>
									{ActionQueueLabels.decision[kind]}
								</Button>
							))}
						</div>
					)}
				</div>
			</div>
			{decision !== null && (
				<ActionDecisionDialog
					kind={decision.kind}
					action={decision.action}
					onClose={() => setDecision(null)}
				/>
			)}
		</>
	);
}
